import { Injectable } from '@angular/core';
import { SocialLink } from '../models/social-link.model';

@Injectable({
  providedIn: 'root'
})
export class SocialLinksService {
  private readonly socialLinks: SocialLink[] = [
    {
      id: 'tiktok',
      name: 'TikTok',
      url: 'https://www.tiktok.com/@bienesraicesdeloriente?_r=1&_t=ZS-93P2haGLxxp',
      iconPath: 'assets/icons/tiktok.svg',
      ariaLabel: 'TikTok',
      order: 4,
      stats: {
        followers: '29.3K',
        likes: '226K'
      },
      preview: {
        imagePath: 'assets/redes/Screenshot_20260126_221515_TikTok.png',
        hasPlayIndicator: true
      }
    },
    {
      id: 'instagram',
      name: 'Instagram',
      url: 'https://www.instagram.com/bienesraices.deloriente?igsh=OG1xcTZ3am5hdDFw&utm_source=qr',
      iconPath: 'assets/icons/instagram.svg',
      ariaLabel: 'Instagram',
      order: 2,
      preview: {
        imagePath: 'assets/redes/Screenshot_20260126_221829_Instagram.png'
      }
    },
    {
      id: 'youtube',
      name: 'YouTube',
      url: 'https://youtube.com/@bienesraicesdeloriente?si=qcaCVbCAq7bQXfT2',
      iconPath: 'assets/icons/youtube.svg',
      ariaLabel: 'YouTube',
      order: 5,
      preview: {
        imagePath: 'assets/redes/Screenshot_20260126_222310_YouTube.png',
        hasPlayIndicator: true
      }
    },
    {
      id: 'facebook',
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1AerfyxtVJ/?mibextid=wwXIfr',
      iconPath: 'assets/icons/facebook.svg',
      ariaLabel: 'Facebook',
      order: 3,
      preview: {
        imagePath: 'assets/redes/Screenshot_20260126_221903_Facebook.png'
      }
    },
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      url: 'https://wa.me/573152601582',
      iconPath: 'assets/icons/whatsapp.svg',
      ariaLabel: 'WhatsApp',
      order: 1,
      preview: {
        imagePath: ''
      }
    }
  ];

  getSocialLinks(): SocialLink[] {
    return [...this.socialLinks].sort((first, second) => first.order - second.order);
  }

  getSocialLinkById(id: string): SocialLink | undefined {
    return this.socialLinks.find(link => link.id === id);
  }
}
